// Per-tab device identifier. Used to scope Twilio Client identities and socket
// routing so each browser tab acts as an independent "device" — outbound calls
// audio-bridge only to the tab that placed them, inbound calls ring all tabs.
//
// sessionStorage (not localStorage) so a fresh tab is treated as a new device,
// matching the WhatsApp Web model where each session is its own endpoint.

const KEY = 'marnic.device_id';

function makeId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID().replace(/-/g, '');
  }
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
}

export function getDeviceId(): string {
  try {
    let id = sessionStorage.getItem(KEY);
    if (!id) {
      id = makeId();
      sessionStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return makeId();
  }
}
